import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MailCheckout } from 'src/app/models/mail-checkout';
import { ModalConfig } from 'src/app/models/modal.config';
import { PermiteReenvioSolicitacao } from 'src/app/models/PermiteReenvioSolicitacao.model';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';
import { StateService } from 'src/app/state/state.service';
import { PreCheckoutViagemService, Values } from '../pre-checkout-viagem/pre-checkout-viagem.service';
import { PreCheckoutVeiculoService, ValuesVeiculo } from './pre-checkout-veiculo.service';

const COLETA_INBOUND = 'COLETA INBOUND';

@Component({
  selector: 'app-pre-checkout-veiculo',
  templateUrl: './pre-checkout-veiculo.component.html',
  styleUrls: ['./pre-checkout-veiculo.component.css']
})
export class PreCheckoutVeiculoComponent implements OnInit {

  tentativa: number = 0;
  translation: any;
  sm: number;
  cpf: string = null;
  nome: string;
  celular: string;
  cdOrigemDescricao: string;
  usuarioBloqueado: boolean = false;
  recipientMail: string = null;
  tipoTransporte: string = null;
  scheduler: any;
  values: ValuesVeiculo = new ValuesVeiculo();
  placas: any[] = [
    {placa:"", tipo:"", validar: true},
    {placa:"", tipo:"", validar: false},
    {placa:"", tipo:"", validar: false}
  ];
  mailCheckout: MailCheckout = new MailCheckout();
  modalConfig: ModalConfig = { 
    modalTitle: ""
  };
  @ViewChild('modalAtualizacaoPlacaViagem') private modalAtualizacaoPlacaViagemComponent: ModalComponent
  pedido: Values = new Values();

  constructor(
    private alertService: AlertService,
    private preCheckoutService: PreCheckoutService,
    private translate: TranslateService,
    private stateService: StateService,
    private preCheckoutQuery: PreCheckoutQuery,
    private spinnerService: SpinnerService,
    private veiculoService: PreCheckoutVeiculoService,
    private viagemService: PreCheckoutViagemService
  ) { }

  openModalAlteracaoPlacaViagem() {
    this.modalConfig.modalTitle = "Aviso";
    this.modalConfig.closeButtonLabel = "Sim";
    this.modalConfig.dismissButtonLabel = "Não";
    this.modalConfig.shouldClose = this.onSalvar.bind(this);
    this.modalConfig.onDismiss = this.onCancelar.bind(this);

    return this.modalAtualizacaoPlacaViagemComponent.open();
  }

  loadWait(){
    setTimeout(function(){
      this.spinnerService.requestStarted("ampulheta.gif", "Aguarde...", true, "Já contactado, clique aqui!", true);
    }.bind(this), 500);
  }

  async onSalvar() {
    this.updatePlacaSM();

    return true;
  }

  getInfoMail(){
    switch(this.tipoTransporte){
      case COLETA_INBOUND:
        this.recipientMail = "coletas.inbound@multivarejogpa.com;vinicius.pereira2@gpabr.com";
        break;
      default:
        this.recipientMail = "gerenciamentologistico@gpabr.com;vinicius.pereira2@gpabr.com";
    }
  }

  getBodyMail(): string{
    let html = "<!DOCTYPE html>";
    html += "<html>";
    html += "<head>";
    html += "<title>Page Title</title>";
    html += "</head>";
    html += "<body style='background-color: #E4E4E4;'>";
    html += "<div style='position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 400px; height: auto; background-color: #ccc; border-radius: 3px; padding: 10px;'>";
    html += "<p><center><strong>&lt;Solicitação encaminhada pelo motorista através do aplicativo Pré-checkout, e-mail automático não responda&gt;</center></strong></p>";
    html += "<br/>";
    html += "<p>Solicitação de substituição da placa do veículo:</p>";
    html += "<p><strong>SM</strong>: "+this.sm+" </p>";
    html += "<p><strong>CPF</strong>: "+this.cpf+" </p>";
    html += "<p><strong>Nome</strong>: "+this.nome+" </p>";
    html += "<p><strong>Celular contato</strong>: "+this.celular+" </p>";
    html += "<p><strong>CD Orig.</strong>: "+this.cdOrigemDescricao+" </p>";
    html += "<p><strong>Placa</strong>: "+this.placas[0].placa+" - <strong>Tipo</strong>: Cavalo</p>";
    html += "</div>";
    html += "</body>";
    html += "</html>";

    return html;
  }

  async cadastraEnvioSolicitacao(): Promise<number>{
    this.mailCheckout.cpf = this.cpf;
    this.mailCheckout.placa = this.placas[0].placa;
    this.mailCheckout.sm = this.sm?.toString();
    this.mailCheckout.tipo = 3;

    return await this.preCheckoutService.CreateMailCheckout(this.mailCheckout).toPromise();
  }

  async permiteReenvioSolicitacao(): Promise<PermiteReenvioSolicitacao>{
    this.mailCheckout.cpf = this.cpf;
    this.mailCheckout.placa = this.placas[0].placa;
    this.mailCheckout.sm = this.sm?.toString();
    this.mailCheckout.tipo = 3;

    return await this.preCheckoutService.PermiteReenvioSolicitacao(this.mailCheckout).toPromise();
  }

  updatePlacaSM(){
    var placas = this.placas.filter(function (item) {
      return item.validar == true;
    }).map(function(item) {
      return item.placa;
    });

    this.preCheckoutService.updatePlaca(this.sm, placas)
    .subscribe(
      (result) => {
        if(result.success){
          this.updatePlacas();
          this.alertService.alertSuccess("Placa atualizada com sucesso!", null);
        }
        else{
          this.alertService.alertWarning(result.message, null);
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar atualizar placas da SM, tente novamente!");
      }
    );
  }

  sendMailPlaca(){
    this.getInfoMail();
    
    let title = "[Pré-Checkout] - Placa: "+this.placas[0].placa+" - Solicitação de Alteração da Placa do Veículo";
    let recipient = this.recipientMail;
    let body = this.getBodyMail();
    
    this.preCheckoutService.sendMail(title, body, recipient)
    .subscribe(
      (result) => {
        if(result)
        {
          this.loadWait();
          this.cadastraEnvioSolicitacao();
          this.updatePlacas();
          this.alertService.alertSuccess("Solicitação de alteração de Placa enviada com sucesso!", null);
          this.schedulerExisteSM();
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar enviar e-mail de solicitação de alteração de placa, tente novamente!");
      }
    );
  }

  //Verifica se existe SM cadastrada a cada 5 minutos
  schedulerExisteSM(){
    this.scheduler = setInterval(() => {
      console.log("setInterval: Consultando SM a cada 5 minutos");
      this.consultaViagem(function(obj){
        //Valida a placa do cavalo
        let exist = obj.placas.find(p=>p.placa==this.placas[0].placa && p.descricao==this.placas[0].tipo);

        if(exist){
          this.alertService.alertSuccess("Placa alterada com sucesso!", null);
          this.spinnerService.requestEnded();
          this.veiculoService.setPlacas(this.placas);
          this.veiculoService.setValue(new ValuesVeiculo(false, true, false, false, false, false));
          if (this.scheduler) {
            clearInterval(this.scheduler);
          }
        }        
      }.bind(this), null);
    }, Utilitarios.WAIT_TIME);
  }

  onCancelar(){
    this.alertService.alertWarning(`Placa do ${this.placas[0].tipo} não confere com a cadastrada na SM`, null);
    this.tentativasLimiteBloqueio(function(){
      this.bloquearMotorista();
    }.bind(this));
  }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();
    
    this.translate.get("preCheckout").subscribe((res) => {
      this.translation = res;
    });

    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.cpf = cpf;
    });

    this.preCheckoutQuery.name$.subscribe((nome)=>{
      this.nome = nome;
    });

    this.preCheckoutQuery.phone$.subscribe((celular)=>{
      this.celular = celular;
    });

    this.viagemService.getValues().subscribe((result)=>{
      this.pedido = result
    });

    this.preCheckoutQuery.originCd$.subscribe((cdOrigem)=>{
      this.cdOrigemDescricao = cdOrigem;
    });

    this.preCheckoutQuery.sm$.subscribe((sm)=>{
      this.sm = sm == null ? 0 : parseInt(sm);
    });

    this.veiculoService.getValues().subscribe((result)=>{
      this.values = result
    });
  }

  bloquearMotorista(){
    this.preCheckoutService.bloquearMotorista(this.cpf)
      .subscribe(
        (result) => {
          if(result){
            let message = "Você excedeu o limite máximo de 3 tentativas!\n";
            message+="Pré-checkout reprovado!";
            this.alertService.alertWarning(message, null);
            this.usuarioBloqueado = true;
          }
        },
        (err) => {
          this.internalError(null);
        }
      );
  }

  tentativasLimiteBloqueio(callBack: any)
  {
    this.tentativa = Utilitarios.tentativasLimiteBloqueio(this.tentativa, callBack);
  }

  consultaViagem(callBack: any, callBack2: any){
    this.preCheckoutService.getViagemBySm(this.sm)
    .subscribe(
      (result) => {
        if(result){
          if(callBack)
            callBack(result);
        }
        else{
          if(callBack2)
            callBack2();
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar recuperar viagem, tente novamente!");
      }
    );
  }
  
  prosseguir(){
    this.consultaViagem(function(obj){
      this.tipoTransporte = obj.tipoTransporte;
      let plates = this.placas.filter(function (p) {
        return p.validar == true && p.placa;
      });

      let placaCavalo = obj.placas.find(p=>p.descricao=="CAVALO")
      let novaPlaca = plates.find(p=>p.tipo=="CAVALO")

      if(placaCavalo && !novaPlaca){
        this.alertService.alertWarning("Informe uma placa do tipo CAVALO", null);
        this.tentativasLimiteBloqueio(function(){
          this.bloquearMotorista();
        }.bind(this));
      }
      else{

        let exist: any = null;

        //Valida a placa da carreta
        if(plates[1] && placaCavalo){
          exist = obj.placas.find(p=>p.placa==plates[1].placa && p.descricao==plates[1].tipo);

          if(!exist){
            this.alertService.alertWarning("Placa da CARRETA não confere com a cadastrada na SM", null);
            this.tentativasLimiteBloqueio(function(){
              this.bloquearMotorista();
            }.bind(this));

            return false;
          }
        }

        //Valida a placa da carreta
        if(plates[2] && placaCavalo){
          exist = obj.placas.find(p=>p.placa==plates[2].placa && p.descricao==plates[2].tipo);

          if(!exist){
            this.alertService.alertWarning("Placa da CARRETA não confere com a cadastrada na SM", null);
            this.tentativasLimiteBloqueio(function(){
              this.bloquearMotorista();
            }.bind(this));

            return false;
          }
        }

        //Valida a placa do cavalo
        if(plates[0]){
          exist = obj.placas.find(p=>p.placa==plates[0].placa && p.descricao==plates[0].tipo);

          if(!exist){
            this.openModalAlteracaoPlacaViagem();
            return false;
          }
        }

        this.updatePlacas();
        this.alertService.alertSuccess("Placa validada com sucesso!", null);
        this.veiculoService.setPlacas(this.placas);
        this.veiculoService.setValue(new ValuesVeiculo(false, true, false, false, false, false));
      }      
    }.bind(this), null);
  }

  updatePlacas(){
    //Atualiza somente com as placas ativas
    this.placas = this.placas.filter(function (p) {
      return p.validar == true && p.placa;
    });

    this.stateService.updatePlates(this.placas);
  }

  validaPlacas(validaTipo: boolean = true): boolean{
    if(!this.placas[0].placa || (!this.placas[0].tipo && validaTipo))
      return false;
    else if(this.placas[0].tipo=="CAVALO" && (!this.placas[1].placa || (!this.placas[1].tipo && validaTipo)))
      return false;
    else if(this.placas[2].validar && (!this.placas[2].placa || (!this.placas[2].tipo && validaTipo)))
      return false;

    return true;
  }

  onBlurMotor(veiculo: any)
  {
    this.consultaVeiculo(veiculo.placa, null, function(result){
      veiculo.placa = result.placa;
      veiculo.tipo = result.tipo;

      if(!result.status){
        this.alertService.alertWarning(result.mensagem, null);
        this.placas[0].placa = null;
      }
      else if(result.tipo=="CAVALO"){
        this.placas[1].validar = true;
      }
      else if(result.tipo=="CARRETA"){
        this.alertService.alertWarning("Informe primeiro a placa do CAVALO para depois informar a placa da CARRETA!", null);
        this.placas[0].placa = null;
      }
      else{
        this.alertService.alertSuccess("Placa validada com sucesso, clique em PROSSEGUIR!", null);
      }

    }.bind(this),function(){
      this.alertService.alertWarning("A placa informada não foi localizada, tente novamente", null);
      this.limpaPlacas();
      this.tentativasLimiteBloqueio(function(){
        this.bloquearMotorista();
      }.bind(this));

    }.bind(this));
  }

  limpaPlacas(){
    this.placas = [
      {placa:"", tipo:"", validar: true},
      {placa:"", tipo:"", validar: false},
      {placa:"", tipo:"", validar: false}
    ];
  }

  onBlurCarreta(veiculo: any)
  {
    this.consultaVeiculo(veiculo.placa, "CARRETA", function(result){
      veiculo.placa = result.placa;
      veiculo.tipo = result.tipo;

      if(!result.status){
        this.alertService.alertWarning(result.mensagem, null);
        veiculo.placa = null;
        veiculo.tipo = null;
      }
    }.bind(this),function(){
      this.alertService.alertWarning("A placa informada não é do tipo carreta, tente novamente!", null);
      veiculo.placa = null;
      veiculo.tipo = null;

      this.tentativasLimiteBloqueio(function(){
        this.bloquearMotorista();
      }.bind(this));

    }.bind(this));
  }

  consultaVeiculo(placa: string, tipo: string = null, callBack1: any = null, callBack2: any = null){
    if(placa){
      this.preCheckoutService.getVeiculo(placa, this.pedido.cdOrigem, tipo)
      .subscribe(
        (result) => {
          if(result)
          {
            this.alertService.limpaAlertMessage();
            if(callBack1)
              callBack1(result);
          }
          else{
            if(callBack2)
              callBack2();
          }
        },
        (err) => {
          this.internalError("Ocorreu um erro ao tentar consultar veículo, tente novamente!");
        }
      );
    }
  }

  internalError(err){
    this.alertService.alertDanger(err || this.translation.internalError, null);
  }

}
